import type { IconAliases } from "vuetify";
import {
  User,
  Users,
  Clock,
  Calendar,
  Settings,
  RefreshCw,
  Shield,
  EyeOff,
  Eye,
  Camera,
  Search,
  LogOut,
  ExternalLink,
  Copy,
  FileText,
  Phone,
  Mail,
  CircleUser,
  CircleCheck,
  MoveLeft,
  Image,
  MapPin,
  Building2,
  Lock,
  House,
  ServerCrash,
  EllipsisVertical,
  CircleX,
  Tag,
  ListChecks,
  HeartHandshake,
  Trophy,
  Flag,
  Megaphone,
  ClipboardList,
  Wrench,
  Hammer,
  Utensils,
  Coffee,
  Car,
  ShieldCheck,
  Shirt,
  Sparkles,
  Hash,
} from "@lucide/vue";

export const icons: Partial<IconAliases> = {
  user: User,
  users: Users,
  clock: Clock,
  copy: Copy,
  calendar: Calendar,
  settings: Settings,
  sync: RefreshCw,
  admin: Shield,
  eyeOff: EyeOff,
  eye: Eye,
  camera: Camera,
  search: Search,
  logout: LogOut,
  link: ExternalLink,
  externLink: ExternalLink,
  file: FileText,
  phone: Phone,
  email: Mail,
  circleUser: CircleUser,
  confirmation: CircleCheck,
  back: MoveLeft,
  image: Image,
  location: MapPin,
  company: Building2,
  lock: Lock,
  dashboard: House,
  serverCrash: ServerCrash,
  ellipsisVertical: EllipsisVertical,
  denied: CircleX,
  tag: Tag,
  tasks: ListChecks,
  heartHandshake: HeartHandshake,
  trophy: Trophy,
  flag: Flag,
  megaphone: Megaphone,
  clipboardList: ClipboardList,
  wrench: Wrench,
  hammer: Hammer,
  utensils: Utensils,
  coffee: Coffee,
  car: Car,
  shieldCheck: ShieldCheck,
  shirt: Shirt,
  sparkles: Sparkles,
  hash: Hash,
} as unknown as Partial<IconAliases>;
